const PASSWORD_SALT = "G8sK8xNm0qAr2zY6";

// src/components/common/commonStyles.js
export const selectSx = (width = "12rem") => ({
  width: { xs: "100%", sm: width },
  minHeight: "2.73rem",
  borderRadius: "0.4285rem",
  "& .MuiOutlinedInput-root": {
    borderRadius: "0.4285rem",
    minHeight: "2.73rem",
    padding: 0,
    display: "flex",
    alignItems: "center",
    "& fieldset": { borderColor: "#d0d7de" },
    // "&:hover fieldset": { borderColor: "#0654a2" },
    "&.Mui-focused fieldset": {
      borderColor: "#0654a2",
      // boxShadow: "0 0 0 0 rgba(0,123,255,.25)",
    },
  },
  "& .MuiSelect-select": {
    padding: "0 0.75rem",
    display: "flex",
    alignItems: "center",
    fontSize: "0.75rem",
    justifyContent: "space-between", // arrow stays on right
    position: "relative",
    textTransform: "capitalize",
  },
  "& .MuiSelect-icon": {
    right: "0.5rem",
    color: "#6c757d",
    display: "block",
    transform: "scale(1.8)", // scale 50% bigger
  },
  "& .MuiMenuItem-root": {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem", // badge + text spacing
  },
});

export const radioLabelSx = {
  "& .MuiFormControlLabel-label": {
    fontWeight: "normal",
    fontSize: "0.8rem",
  },
};

export const selectMenuProps = {
  PaperProps: {
    sx: {
      maxHeight: 170, // shows ~5 items
      overflowY: "auto",
      borderRadius: "0.5rem",
      mt: 0.5, // small spacing below select
    },
  },
};

export const autoCompleteProps = {
  disablePortal: true,
  ListboxProps: {
    sx: {
      maxHeight: 170,
      overflowY: "auto",
    },
  },
  sx: {
    "& .MuiAutocomplete-clearIndicator": {
      transform: "translate(15px, -12px)",
    },
  },
};

export const convertTo24Hour = (time) => {
  if (!time) return "";
  const [timePart, modifier] = time.split(" ");
  let [hours, minutes] = timePart.split(":");

  if (modifier === "PM" && hours !== "12") {
    hours = String(parseInt(hours, 10) + 12);
  }
  if (modifier === "AM" && hours === "12") {
    hours = "00";
  }

  return `${hours.padStart(2, "0")}:${minutes}`;
};
// export const autoCompleteProps = {
//   disablePortal: false, // ensures popup renders outside any scrollable container
//   slotProps: {
//     paper: {
//       sx: {
//         maxHeight: 170, // popup height
//         overflowY: "auto", // only the popup scrolls
//         borderRadius: "0.5rem",
//         mt: 0.5,
//       },
//     },
//   },
// };

export const authorizedUser = (res) => {
  if (res?.code === 440) {
    localStorage.clear();
    window.location.href = `/auth/login?error=Your session has expired`;
  } else {
    return;
  }
};

export const ISOToDDMMYYYY = (dateStr) => {
  if (!dateStr) return "-";

  const parts = dateStr.split("T")[0]; // "2026-04-30"
  const [year, month, day] = parts.split("-");

  const months = [
    "Jan","Feb","Mar","Apr","May","Jun",
    "Jul","Aug","Sep","Oct","Nov","Dec"
  ];

  return `${day} ${months[Number(month) - 1]} ${year}`;
};

export const wrapCell = (value, maxWidth = "10rem") => (
  <div
    style={{
      whiteSpace: "normal",
      wordBreak: "break-word",
      overflowWrap: "break-word",
      lineHeight: "1.4",
      maxWidth,
    }}
  >
    {value ?? "-"}
  </div>
);

export const encodePassword = (password) => {
  const salted = PASSWORD_SALT + password;
  return btoa(salted); // Convert the salted string into Base64 format
};

